import React from 'react';

/**
 * 郵便番号入力 + 住所検索ボタン の共通コンポーネント
 * テーブル行（TR）ごと描画する
 *
 * Props:
 *   label          - TH に表示するラベル文字列
 *   required       - 必須マーク表示
 *   name           - input の name 属性
 *   value          - input の value
 *   onChange       - input の onChange (e を受け取る。フォーマット処理は呼び出し元で行う)
 *   onSearch       - 住所検索ボタン onClick
 *   error          - バリデーションエラー文字列
 *   postalMessage  - 検索結果メッセージ (useAddressSearch から)
 *   isSuccess      - 検索成功フラグ (useAddressSearch から)
 *   disabled       - 送信中などの無効化フラグ
 *   placeholder    - input のプレースホルダー
 *   maxLength      - input の maxLength
 *   helpText       - 入力欄下部のヘルプテキスト
 *   onCompositionStart / onCompositionEnd - IME ハンドラ (任意)
 *   thStyle / tdStyle / inputStyle / errorStyle / helpTextStyle / requiredStyle
 *   rowClassName / thClassName / tdClassName
 */
const PostalCodeInput = ({
  label,
  required = false,
  name,
  value,
  onChange,
  onSearch,
  error,
  postalMessage,
  isSuccess,
  disabled = false,
  placeholder = '123-4567',
  maxLength = '8',
  helpText,
  onCompositionStart,
  onCompositionEnd,
  // style props (呼び出し元のスタイル体系に合わせて渡す)
  thStyle = {},
  tdStyle = {},
  inputStyle = {},       // エラー状態のスタイル計算は呼び出し元で済ませて渡す
  errorStyle = {},
  helpTextStyle = {},
  requiredStyle = {},
  rowClassName = '',
  thClassName = '',
  tdClassName = '',
}) => (
  <tr className={rowClassName}>
    <th style={thStyle} className={thClassName}>
      <span>{label}</span>
      {required && <span style={requiredStyle}> *</span>}
    </th>
    <td style={tdStyle} className={tdClassName}>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
        <input
          type="text"
          name={name}
          value={value}
          onChange={onChange}
          onCompositionStart={onCompositionStart}
          onCompositionEnd={onCompositionEnd}
          placeholder={placeholder}
          maxLength={maxLength}
          style={{ ...inputStyle, flex: 1 }}
          disabled={disabled}
        />
        <button
          type="button"
          onClick={() => onSearch(value)}
          disabled={disabled}
          style={{
            padding: '6px 12px',
            backgroundColor: '#09529f',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            whiteSpace: 'nowrap',
            opacity: disabled ? 0.6 : 1
          }}
          onMouseOver={(e) => !disabled && (e.target.style.backgroundColor = '#073d75')}
          onMouseOut={(e) => !disabled && (e.target.style.backgroundColor = '#09529f')}
        >
          住所検索
        </button>
      </div>

      {error && (
        <div style={errorStyle}>{error}</div>
      )}

      {postalMessage && (
        <div style={{
          marginTop: '5px',
          fontSize: '13px',
          color: isSuccess ? '#28a745' : '#666'
        }}>
          {postalMessage}
        </div>
      )}

      {helpText && (
        <div style={helpTextStyle}>{helpText}</div>
      )}
    </td>
  </tr>
);

export default PostalCodeInput;